export default "__VITE_ASSET__dfPl9t7a__"